/**
 * Fond global du backoffice : fond froid uni de la direction « Univers »
 * de finance-for-you.com, derrière tout le contenu.
 */
export function MeshBackground() {
  return <div className="fixed inset-0 -z-10 bg-ground pointer-events-none" aria-hidden="true" />;
}
